import { NotificationTypes } from 'uf/tasks/NotificationTypes';

export const mapExport = {
  MAPEXPORT_STARTED: NotificationTypes.MAPEXPORT_STARTED,
  MAPEXPORT_DONE: NotificationTypes.MAPEXPORT_DONE,
  MAPEXPORT_ERROR: NotificationTypes.MAPEXPORT_ERROR,
} as const;
